import {object, string} from "yup";

import type {Field, TForm} from "types";
import {EyeHideIcon, EyeShowIcon} from "assets/icons";

const fields: Field[] = [
	{
		type: "password",
		name: "currentPassword",
		label: "Password",
		placeholder: "Enter Your Password",
		RightIcon: EyeHideIcon,
		RightToggledIcon: EyeShowIcon,
	},
	{
		type: "text",
		name: "code",
		label: "Enter code from Authenticator",
		placeholder: "Enter Code",
		// RightIcon: EyeHideIcon,
		// RightToggledIcon: EyeShowIcon,
	},
];

const schema = object().shape({
	currentPassword: string().required("Password is a required field"),
	code: string().required("Code is a required field"),
});

const verifyNDisable: TForm = {
	fields,
	schema,
};

export default verifyNDisable;
